import fetchLicense from './fetchLicense'

export { fetchLicense }

export interface ILicense extends ILicenseIntegration {
  license: Date | string
  licenseType: LicenseType
  rawDate?: Date
  roomLimit?: number
  active?: number
  startLicense?: Date | string
  source?: string
  rawLicense?: string
  has_invoices: boolean
  has_workers: boolean
  sub?: any
}

export interface ILicenseServices {
  booking: ILicense
  iCalendar: ILicense
  invoice: ILicense
  airbnb: ILicense
  boxBuy: {status: number}
}

export interface ILicenseIntegration {
  status?: IntegrationStatus
  id?: number
  trial?: number
  link?: string
}

export enum IntegrationStatus {
  Inactive = 0,
  Active = 1,
  NotPurchased = 2,
  NotConfigured = 3,
  NotSupported = 4,
}

export enum LicenseType {
  LICENSE_WEB_ANDROID = 1,
  LICENSE_WEB_IOS = 2,
  LICENSE_WEB_ANDROID_IOS = 3,
  LICENSE_BOOKING_COM = 4,
  LICENSE_ICALENDAR = 5,
  LICENSE_PERMISSIONS = 6,
  LICENSE_INVOICE = 7,
  LICENSE_PREMIUM_ROOMS = 10,
  LICENSE_PREMIUM_BASIC = 11,
  LICENSE_PREMIUM_ASSISTENT = 12,
  LICENSE_PREMIUM_PROFESSIONAL = 13,
  LICENSE_PREMIUM_LITE = 21,
  LICENSE_PREMIUM_PLUS = 22,
  LICENSE_PREMIUM_PRO = 23,
  LICENSE_PREMIUM_MAX = 24,
}
